import { useNavigate } from 'react-router-dom';
// custom hooks
import { BroadcastChannelMessagesEnum, postMessage } from './useBroadcastChannel';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
// api
import { authApi } from 'redux-store/api/auth';
// slices
import {
  handleAuth,
  handleDeleteCompanyId,
  handleSetInactiveInitial,
} from 'redux-store/slices/auth-slice';
import { handleSetCompleted } from 'redux-store/slices/account-stepper-slice';
// utils
import { clearAuthData } from 'utils/authData';
import { logoutSession } from 'utils/authRefresh';

interface IOptions {
  preventNavigation?: boolean;
  withoutPostMessage?: boolean;
  withoutResetState?: boolean;
}

export const useLogOut = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onLogOut = async (options?: IOptions) => {
    const lastViewedActivityFeed = localStorage.getItem('lastViewedActivityFeed');

    void logoutSession();

    localStorage.clear();
    if (lastViewedActivityFeed) {
      localStorage.setItem('lastViewedActivityFeed', lastViewedActivityFeed);
    }
    clearAuthData();
    dispatch(handleAuth(false));
    dispatch(handleDeleteCompanyId());
    dispatch(handleSetCompleted(null));
    dispatch(handleSetInactiveInitial());
    if (!options?.withoutResetState) {
      dispatch(authApi.util.resetApiState());
    }
    if (!options?.withoutPostMessage) {
      postMessage({ message: BroadcastChannelMessagesEnum.LOG_OUT });
    }
    if (!options?.preventNavigation) {
      navigate('/sign-in');
    }
  };

  return { onLogOut };
};
